import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Lote 127 — faixa no Painel, só para o administrador, quando o proxy do DJEN pede atenção (reserva em uso, nenhum
// proxy respondendo, pacote de dados acabando). Sem problema, não ocupa espaço. Alerta nunca fica recolhido.
export default function ProxyDjenAviso() {
  const { user } = useAuth();
  const [alertas, setAlertas] = useState([]);
  useEffect(() => {
    if (!user?.is_owner) return;
    http.get("/admin/djen-proxy/status").then((r) => setAlertas(r.data?.alertas || [])).catch(() => {});
  }, [user?.is_owner]);
  if (!user?.is_owner || alertas.length === 0) return null;
  const erro = alertas.some((a) => a.nivel === "erro");
  return (
    <div role="alert" data-testid="proxy-djen-aviso-painel"
      className={`mb-4 flex items-start gap-3 rounded-md border px-4 py-3 text-sm ${erro ? "border-red-200 bg-red-50 text-red-900" : "border-amber-200 bg-amber-50 text-amber-900"}`}>
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={2} />
      <div className="min-w-0 space-y-1">
        {alertas.map((a) => <p key={a.tipo} data-testid={`proxy-aviso-${a.tipo}`} className="font-semibold">{a.texto}</p>)}
        <Link to="/admin" className="text-xs font-semibold underline">Abrir Administração &gt; Proxy do DJEN</Link>
      </div>
    </div>
  );
}
